// extracted by mini-css-extract-plugin
export default {"title":"FavoritePage_title__O0Rf+","noContent":"FavoritePage_noContent__EfZYH","wrapperItem":"FavoritePage_wrapperItem__KsE7p"};